import React, { Component } from "react";
import logo from "../images/ipark-logo.png";
import adminIcon from "../images/person-circle-outline.svg";
import { Link, NavLink } from "react-router-dom";
import "../styles/nav.css";

//redux
import { logoutUser } from "../redux/actions/userActions";
import { connect } from "react-redux";

//font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCog, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";

class Nav extends Component {
  handleLogout = e => {
    e.preventDefault();
    this.props.logoutUser();
  };

  render() {
    return (
      <div>
        <div className="navbar navbar-expand-lg navbar-light p-0">
          <button
            className="navbar-toggler"
            data-toggle="collapse"
            data-target="#collapse_target"
          >
            <span className="navbar-toggler-icon"></span>
            <Link className="navbar-brand nav-logo-mobile" to="/">
              <img src={logo} alt="" className="" />
            </Link>
            <div class="btn-group">
              <div
                class=" btn dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img src={adminIcon} alt="" className="adminIcon" />
                <h6 className="d-inline-block mr-2">Account</h6>
              </div>
              <div class="dropdown-menu">
                <div className="menuDiv">
                  <Link className="accSettings" to="/user">
                    <FontAwesomeIcon
                      className="accountIcon"
                      icon={faUserCog}
                      size={70}
                    />
                    <p>Account Settings</p>
                  </Link>
                </div>
                <div className="menuDiv" onClick={this.handleLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} />
                  <p>Logout</p>
                </div>
              </div>
            </div>
          </button>
          <div className="collapse navbar-collapse" id="collapse_target">
            <Link className="navbar-brand p-3 nav-brand-logo" to="/">
              <img src={logo} alt="" className="" />
            </Link>
            {this.props.user.role !== "admin" && (
              <ul className="navbar-nav text-center list-div">
                <li className="nav-item">
                  <NavLink className="nav-links" to="/" exact>
                    Home
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-links" to="/soon" exact>
                    About
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-links" to="/soon2" exact>
                    Contact
                  </NavLink>
                </li>
              </ul>
            )}
          </div>

          <div class="btn-group account-div">
            <div
              class=" btn dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img src={adminIcon} alt="" className="adminIcon" />
              <h6 className="d-inline-block mr-2">Account</h6>
            </div>
            <div class="dropdown-menu">
              <div className="menuDiv">
                <Link className="accSettings" to="/user">
                  <FontAwesomeIcon
                    className="accountIcon"
                    icon={faUserCog}
                    size={70}
                  />
                  <p>Account Settings</p>
                </Link>
              </div>
              <div className="menuDiv" onClick={this.handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} />
                <p>Logout</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user,
  authenticated: state.user.authenticated
});

const mapActionsToProps = {
  logoutUser
};

export default connect(mapStateToProps, mapActionsToProps)(Nav);
